import { render, staticRenderFns } from "./RegionDialog.vue?vue&type=template&id=6eb46954"
import script from "./RegionDialog.vue?vue&type=script&lang=js"
export * from "./RegionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eb46954')) {
      api.createRecord('6eb46954', component.options)
    } else {
      api.reload('6eb46954', component.options)
    }
    module.hot.accept("./RegionDialog.vue?vue&type=template&id=6eb46954", function () {
      api.rerender('6eb46954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/region/components/RegionDialog.vue"
export default component.exports